import React, { useEffect, useState } from 'react'
import * as S from './styles'

import DetailsIcon from './DetailsIcon'
import DetailsSubItem from './SubItem'

import { isValueDefined } from '@/services/functions'
import { PAGE_PATHS } from '@/services/paths'

import { useTranslation } from 'react-i18next'
import { useRouter } from 'next/router'

const DetailsItem = ({ data }) => {
  const { t } = useTranslation()
  const router = useRouter()

  const [defaultIndex, setDefaultIndex] = useState()

  const [title, setTitle] = useState('')
  const [text, setText] = useState()
  const [buttonText, setButtonText] = useState('')

  useEffect(() => {
    if (!router) return

    const index = router.query.subsection
    if (index) {
      setDefaultIndex(parseInt(index))
    }
  }, [router])

  useEffect(() => {
    if (!isValueDefined(defaultIndex)) return

    setTimeout(() => {
      document
        .getElementById(`section-subitem-${defaultIndex}`)
        .scrollIntoView({ behavior: 'smooth' })
    }, 1000)
  }, [defaultIndex])

  useEffect(() => {
    if (!data) return
    setTitle(t(data.title))
    setButtonText(t('buttons.startNow'))

    if (data.text) {
      setText(t(data.text))
    }
  }, [t, data])

  return (
    data && (
      <S.DetailsItemContainer id="current_detail_item">
        <S.DetailsItemMainTextContainer>
          <DetailsIcon data={data} />
          <h2>{title}</h2>
          {text && <p>{text}</p>}
        </S.DetailsItemMainTextContainer>

        {data.contents.map((item, i) => (
          <DetailsSubItem key={i} index={i} data={item} />
        ))}

        <a
          href={PAGE_PATHS.contact}
          id={`btn_details_${title}`}
          className="btn lg round"
        >
          <span>{buttonText}</span>
          <span className="material-icons-round">arrow_forward</span>
        </a>
      </S.DetailsItemContainer>
    )
  )
}

export default DetailsItem
